import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fillNonNullValues, THUNK_STATUS } from "@duosoftbg/nacid-components";
import { baseEndpointPaths, getApplicationById } from "../../../../services/serviceCalls";
import { initialRudiAdditionalDocApplication } from "../../../../init/rudiAdditionalDocInitialValues";

export const fetchRudiAdditionalDocForm = createAsyncThunk(
  "rudiAdditionalDocForm/fetchStatus",
  async (id: number | string) => {
    const response = await getApplicationById(baseEndpointPaths.rudiAdditionalDoc, id)();
    return response;
  },
);

const rudiAdditionalDocFormSlice = createSlice({
  name: "RudiAdditionalDocStoreSlice",
  initialState: initialRudiAdditionalDocApplication,
  reducers: {
    setRequestIdentifier: (state, action) => {
      state.id = action.payload;
    },
    completeApplicantStep: (state, action) => {
      state.applicantDetails = action.payload;
      state.steps[0].completed = true;
    },
    completeAdditionalDocDetailStep: (state, action) => {
      state.additionalDocDetail = action.payload;
      state.steps[1].completed = true;
    },
    completeDocumentStep: (state, action) => {
      state.documentDetails = action.payload;
      state.steps[2].completed = true;
    },
    resetRudiAdditionalDocRequest: () => initialRudiAdditionalDocApplication,
    setStepApplicantEdited: (state, action) => {
      state.steps[0].isEdited = action.payload;
    },
    setStepAdditionalDocDetailEdited: (state, action) => {
      state.steps[1].isEdited = action.payload;
    },
    setStepDocumentsEdited: (state, action) => {
      state.steps[2].isEdited = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchRudiAdditionalDocForm.fulfilled, (state, action) => {
      state.dataStateStatus = THUNK_STATUS.FULFILLED;

      const updatedValues = { ...initialRudiAdditionalDocApplication };
      fillNonNullValues(action.payload.data, updatedValues);

      state.id = updatedValues.id;
      state.applicantDetails = updatedValues.applicantDetails;
      state.additionalDocDetail = updatedValues.additionalDocDetail;
      state.documentDetails = updatedValues.documentDetails;

      state.steps[0].completed = true;
      if (state.additionalDocDetail.entryNumber && state.additionalDocDetail.entryNumber !== "") {
        state.steps[1].completed = true;
      } else {
        state.steps[1].completed = false;
      }
      if (state.documentDetails.attachments.length > 0) {
        state.steps[2].completed = true;
      } else {
        state.steps[2].completed = false;
      }
    });
    builder.addCase(fetchRudiAdditionalDocForm.pending, (state, action) => {
      state.dataStateStatus = THUNK_STATUS.PENDING;
    });
    builder.addCase(fetchRudiAdditionalDocForm.rejected, (state, action) => {
      state.dataStateStatus = THUNK_STATUS.REJECTED;
    });
  },
});

export const {
  setRequestIdentifier,
  completeApplicantStep,
  completeDocumentStep,
  resetRudiAdditionalDocRequest,
  setStepApplicantEdited,
  setStepDocumentsEdited,
  completeAdditionalDocDetailStep,
  setStepAdditionalDocDetailEdited,
} = rudiAdditionalDocFormSlice.actions;
export default rudiAdditionalDocFormSlice.reducer;
